import axios from 'axios'
import {ResponseObject} from '../../../../../models'
import {BathRoomModel} from '../models'
const BASEURL = process.env.REACT_APP_DEV_API_HOTELERIA_URL

export async function createBathRoomService(dto: BathRoomModel) {
  return await axios.post<ResponseObject<BathRoomModel>>(`${BASEURL}/bathRoom/createBathRoom`, dto)
}
